import { GetMeetingRequestsByReviewerQuery, GetMeetingRequestsByReviewerQueryVariables } from './../../../types'
import { ApolloError, useQuery } from '@apollo/client'
import { GET_MEETING_REQUESTS_BY_REVIEWER } from '../MeetingRequestQueries'

export const useMeetingRequestByReviewer = (
  reviewerId: number,
): {
  data: GetMeetingRequestsByReviewerQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<GetMeetingRequestsByReviewerQuery, GetMeetingRequestsByReviewerQueryVariables>(
    GET_MEETING_REQUESTS_BY_REVIEWER,
    {
      variables: {
        reviewerId: reviewerId,
      },
    },
  )

  return { data, error, loading }
}
